// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__7amvH","rightAdornment":"Header_rightAdornment__24qad"};